


import { Modal } from "reactstrap";
import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import React, { useState, useEffect,useRef } from "react";

const FiltrationPopUp = ({
  isOpen,
  onClose,
  filterpumpName,
   container,
}: {
  isOpen: boolean;
  onClose: () => void;
   filterpumpName: string;
    style?: React.CSSProperties;
        container?: HTMLElement | null;
}) => {
   const targetRef = useRef<HTMLDivElement>(null); 
  const [PumpData, setpumpdata] = useState<any[]>([]);
  const getAllPumpingStations = async () => {
    try {
      const response = await ApiService.axiosApi(`/tags`, {
        method: "GET",
      });

      if (response.success) {
        
        setpumpdata(response.data);
       
      } else {
         console.log("Failed to fetch pumping stations");
      }
    } catch (error) {
      console.error("Error fetching pumping stations:", error);
       console.log("Error fetching pumping stations");
    }
  };

 useEffect(() => {
   getAllPumpingStations();
 
   // Move setInterval inside useEffect
   const interval = setInterval(() => {
     getAllPumpingStations();
   }, 5000); 
 
   // Cleanup interval on unmount
   return () => clearInterval(interval);
 }, []); // keep dependency array
 
 
  const filterPumpDisplayNames: { [key: string]: string } = {
  FLT1: "Filter-1",
  FLT2: "Filter-2",
  FLT3: "Filter-3",
  FLT4: "Filter-4",
  FLT5: "Filter-5",
};



  return (
    <>
      <Modal isOpen={isOpen} size="md" centered toggle={onClose}
      style={{
        zIndex: 9999, // High z-index
      }}
       container={container || document.body} // Use container prop or fallback to body
        
      modalClassName="custom-modal-class"
        backdropClassName="custom-backdrop-class"
        contentClassName="custom-content-class">
        <div className="panel1-filtrationpopup w-100">
          <div className="panel-header-filtrationpopup">
            <span className="title-filtrationpopup">{filterPumpDisplayNames[filterpumpName] || filterpumpName}</span>
            <div className="header-actions-filtrationpopup">
              <button className="refresh-filtrationpopup"onClick={getAllPumpingStations} > &#x21bb;</button>
              <button className="close-filtrationpopup" onClick={onClose}>
              ✖
              </button>
            </div>
          </div>

          <div className="sub-header-filtrationpopup">SYSTEM IN WEB SCADA</div>

          <div
            className="status-box1-filtrationpopup "
            style={{
              width: "95%",
            }}
          >
            <div className="status-title-filtrationpopup ">FILTER PUMP</div>
            <div className="status-grid-filtrationpopup">
              <div className="status-item1-filtrationpopup">
                {" "}
                <span
                  className="status-filtrationpopup"
                  style={{
                    backgroundColor: PumpData.find(
                      (t) => t.name === `${filterpumpName}_MTR_ON` && t.value === "True"
                    )
                      ? "green"
                      : "grey",
                  }}
                ></span>{" "}
                ON STATUS
              </div>
              <div className="status-item1-filtrationpopup">
                <span
                  className="status-filtrationpopup"
                  style={{
                    backgroundColor: PumpData.find(
                      (t) => t.name === `${filterpumpName}_RS` && t.value === "True"
                    )
                      ? "green"
                      : "grey",
                  }}
                ></span>{" "}
                REMOTE STATUS
              </div>
              <div className="status-item1-filtrationpopup">
                <span
                  className="status-filtrationpopup"
                  style={{
                    backgroundColor: PumpData.find(
                      (t) => t.name === `${filterpumpName}_MTR_OFF` && t.value === "True"
                    )
                      ? "red"
                      : "grey",
                  }}
                ></span>{" "}
                OFF STATUS
              </div>
              <div className="status-item1-filtrationpopup">
                <span
                  className="status-filtrationpopup"
                  style={{
                    backgroundColor: PumpData.find(
                      (t) => t.name === `${filterpumpName}_RDY` && t.value === "True"
                    )
                      ? "green"
                      : "grey",
                  }}
                ></span>{" "}
                READY STATUS(MANUAL MODE)
              </div>
              <div className="status-item1-filtrationpopup">
                <span
                  className="status-filtrationpopup"
                  style={{
                    backgroundColor: PumpData.find(
                      (t) => t.name === `${filterpumpName}_TP` && t.value === "True"
                    )
                      ? "yellow"
                      : "grey",
                  }}
                ></span>{" "}
                TRIP STATUS
              </div>
              <div className="status-item1-filtrationpopup">
                <span
                  className="status-filtrationpopup"
                  style={{
                    backgroundColor: PumpData.find(
                      (t) => t.name === `${filterpumpName}_HLTHY` && t.value === "True"
                    )
                      ? "green"
                      : "grey",
                  }}
                ></span>{" "}
                HEALTHY STATUS(AUTO MODE)
              </div>
              <div className="status-item1-filtrationpopup">
                <span
                  className="status-filtrationpopup"
                  style={{
                    backgroundColor: PumpData.find(
                      (t) => t.name === `${filterpumpName}_DPS` && t.value === "True"
                    )
                      ? "red"
                      : "grey",
                  }}
                ></span>{" "}
                DPS HIGH ALARM
              </div>
              <div className="status-item1-filtrationpopup">
                <span
                  className="status-filtrationpopup"
                  style={{
                    backgroundColor: PumpData.find(
                      (t) => t.name === `${filterpumpName}_MTR_ON` && t.value === "True"
                    )
                      ? "green"
                      : "grey",
                  }}
                ></span>{" "}
                INLET VALVE OPEN
              </div>
            </div>
          </div>

          <div
            className="status-box2-filtrationpopup "
            style={{
              width: "95%",
            }}
          >
            <div className="status-title-filtrationpopup">RUN HOURS</div>
            <div className="run-hours-filtrationpopup">
              <div style={{ color: "white" }}>
                RUN HOURS FOR DAY (HH:MM):
                <span style={{ color: "white" }}>{PumpData.find(t => t.name === `${filterpumpName}_MTR_DAILY_RN_HR`)?.value ?? 0}:{String(PumpData.find(t => t.name === `${filterpumpName}_MTR_RN_MIN`)?.value ?? 0).padStart(2, '0')}</span>
              </div>
              <div style={{ color: "white" }}>
                CUMULATIVE RUN HOURS (HH:MM):{" "}
                <span style={{ color: "white" }}>{PumpData.find(t => t.name === `${filterpumpName}_MTR_TTL_RN_HRS`)?.flT_Run_HH_MM ?? 0}</span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default FiltrationPopUp;
